import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useFilters from '../useFilters';
import AnalyticsApi from 'libs/api/analytics';
import UIHelper from 'helpers/UIHelper';
import { usePdf } from '../../../../hooks/usePdf';

const api = new AnalyticsApi('charts/all/');

const format = (v) => `${v}%`;

const defaultState = {
  tableData: [],
  lineChartData: [],
  barChart: [],
  barChangeLine: [],
  total: {},
};

const useFootfall = (isPrint) => {
  const { t } = useTranslation();
  const { handleDownloadPdf, loadingPdf, createCustomEvent } = usePdf();
  const [errors, setErrors] = useState([]);
  const { filters, title, searchParams } = useFilters(false, true);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(defaultState);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const params = {
          ...Object.fromEntries([...searchParams]),
        };
        if (!params.by_period || !params.by_shopping_center) return;
        const { data } = await api.getFootfalls({ params });
        setData(data);
      } catch (e) {
        const error = e?.response?.data?.date || [];
        if (error.length) {
          UIHelper.openNotificationWithIcon('error', error.join(', '));
        }
        setErrors(UIHelper.showAnalyticsError(e));
        console.log(e);
      } finally {
        setLoading(false);
        if (isPrint) {
          createCustomEvent();
        }
      }
    })();
  }, [searchParams, isPrint]);

  return {
    data,
    filters,
    title,
    searchParams,
    format,
    loading,
    handleDownloadPdf,
    loadingPdf,
    errors,
  };
};

export default useFootfall;
